import { useState } from 'react';
import { Marker, Popup } from 'react-map-gl/mapbox';
import type { DockPoint } from '../../../../types/gcs/dockPoint';
import { getMapElementZIndex, MapElement } from '../../../../types/ui/mapElement';
import { Text } from '../../../../components/general/Text';

interface DockPointMarkerProps {
  dockPoint: DockPoint;
}

export const DockPointMarker = ({ dockPoint }: DockPointMarkerProps) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <>
      <Marker
        longitude={dockPoint.location.lng}
        latitude={dockPoint.location.lat}
        anchor='center'
        style={{ zIndex: getMapElementZIndex(MapElement.DOCK_POINT) }}
      >
        <svg
          width='32'
          height='32'
          viewBox='0 0 40 40'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          style={{ cursor: 'pointer' }}
          onClick={(event) => {
            event.stopPropagation();
            setIsPopupOpen((prev) => !prev);
          }}
        >
          <circle cx='20' cy='20' r='19' fill='var(--map-element-on-ground)' stroke='white' strokeWidth='2' />
          <path
            d='M6 1.5C6 1.77614 5.77614 2 5.5 2H4.5C4.22386 2 4 2.22386 4 2.5V3.5C4 3.77614 4.22386 4 4.5 4H9.5C9.77614 4 10 3.77614 10 3.5V2.5C10 2.22386 10.2239 2 10.5 2H11.5C11.7761 2 12 2.22386 12 2.5V3.5C12 3.77614 12.2239 4 12.5 4H17.499C17.7752 4 17.999 3.77614 17.999 3.5V2.5C17.999 2.22386 17.7752 2 17.499 2H16.5C16.2239 2 16 1.77614 16 1.5V0.5C16 0.223858 16.2239 0 16.5 0H21.5C21.7761 0 22 0.223858 22 0.5V1.5C22 1.77614 21.7761 2 21.5 2H20.499C20.2229 2 19.999 2.22386 19.999 2.5V5.5C19.999 5.77614 19.7752 6 19.499 6H15.5C15.2239 6 15 6.22386 15 6.5V9.5C15 9.77614 15.2239 10 15.5 10C15.7761 10 16 10.2239 16 10.5V11.5C16 11.7761 16.2239 12 16.5 12H20.5C20.7761 12 21 12.2239 21 12.5C21 12.7761 20.7761 13 20.5 13H19.5C19.2239 13 19 13.2239 19 13.5V14.5C19 14.7761 18.7761 15 18.5 15H17.5C17.2239 15 17 14.7761 17 14.5V13.5C17 13.2239 16.7761 13 16.5 13H5.5C5.22386 13 5 13.2239 5 13.5V14.5C5 14.7761 4.77614 15 4.5 15H3.5C3.22386 15 3 14.7761 3 14.5V13.5C3 13.2239 2.77614 13 2.5 13H1.5C1.22386 13 1 12.7761 1 12.5C1 12.2239 1.22386 12 1.5 12H5.5C5.77614 12 6 11.7761 6 11.5V10.5C6 10.2239 6.22386 10 6.5 10C6.77614 10 7 9.77614 7 9.5V6.5C7 6.22386 6.77614 6 6.5 6H2.5C2.22386 6 2 5.77614 2 5.5V4.00049C2 4.00022 2.00022 4 2.00049 4C2.00076 4 2.00098 3.99978 2.00098 3.99951V2.5C2.00098 2.22386 1.77712 2 1.50098 2H0.5C0.223858 2 0 1.77614 0 1.5V0.5C0 0.223858 0.223858 0 0.5 0H5.5C5.77614 0 6 0.223858 6 0.5V1.5ZM8 11.5C8 11.7761 8.22386 12 8.5 12H13.5C13.7761 12 14 11.7761 14 11.5V10.5C14 10.2239 13.7761 10 13.5 10H8.5C8.22386 10 8 10.2239 8 10.5V11.5Z'
            fill='white'
          />
        </svg>
      </Marker>
      {isPopupOpen && (
        <Popup
          longitude={dockPoint.location.lng}
          latitude={dockPoint.location.lat}
          anchor='bottom'
          offset={32}
          className='marker-popup'
          closeButton={true}
          closeOnClick={true}
          onClose={() => setIsPopupOpen(false)}
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <Text variant='body2'>{dockPoint.name}</Text>
          </div>
        </Popup>
      )}
    </>
  );
};
